module.exports = __webpack_public_path__ + "img/addToWalletAddBankRe.48f31568.svg";